import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import serviceDashboardService, {
  ManagerialDashboardFilters,
  ManagerialDashboardResponse,
} from "@/services/service-dashboard.service";

const REFRESH_INTERVAL_MS = 10 * 60 * 1000;

export type UseGetManagerialDashboardProps = ManagerialDashboardFilters & {
  autoRefresh?: boolean;
};

export type UseGetManagerialDashboardReturn = {
  data: ManagerialDashboardResponse | null;
  isLoading: boolean;
  isRefreshing: boolean;
  error: Error | null;
  refresh: () => void;
};

const useGetManagerialDashboard = ({
  year,
  month,
  startDate,
  endDate,
  queueIds,
  userIds,
  workflowIds,
  tagNames,
  autoRefresh = false,
}: UseGetManagerialDashboardProps): UseGetManagerialDashboardReturn => {
  const {
    data = null,
    isLoading,
    isValidating,
    error,
    mutate,
  } = useSWR(
    [SWR_KEYS.getManagerialDashboard, year, month, startDate, endDate, queueIds, userIds, workflowIds, tagNames],
    () =>
      serviceDashboardService.managerial({
        year,
        month,
        startDate,
        endDate,
        queueIds, userIds, workflowIds, tagNames }),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      errorRetryCount: 0,
      keepPreviousData: true,
      refreshInterval: autoRefresh ? REFRESH_INTERVAL_MS : 0,
    }
  );

  return {
    data,
    isLoading,
    isRefreshing: Boolean(data) && isValidating,
    error,
    refresh: () => {
      void mutate();
    },
  };
};

export default useGetManagerialDashboard;
